// Co-located query-key factory for OwnerPicker's per-type candidate searches.
// Keeps queryKey literals out of the component per the stale-after-save gate
// (src/test/staleAfterSaveGate.test.ts). These are read-only typeahead lookups
// with no mutations to invalidate; the factory exists so the keys live in one
// `*Keys` file rather than inline in the picker.

export const ownerPickerKeys = {
  /** `bucket` is the owner-type slug (persons/entities/businesses/deals/
   *  brokers/vendors/loans); `term` is the current search string. */
  search: (bucket: string, term: string) =>
    ["owner-picker", bucket, term] as const,
};
